<script>
export default {
  name: 'SkeletonContent',
  props: {
    size: {
      type: Boolean,
      default: true
    },
    paragraph: {
      type: Boolean,
      default: false
    },
    title: {
      type: Boolean,
      default: false
    }
  },

  render(h) {
    let titleData = {
      style: {
        width: '38%'
      },
      class: {
        'skeleton-title': true
      }
    }
    let paragraphData = {
      class: {
        'skeleton-paragraph': true
      }
    }
    let content = []
    if (this.title) {
      content.push(h('div', titleData))
    }
    if (this.paragraph) {
      content.push(h('ul', paragraphData, [this.$slots.default]))
    }
    return h('div', {
      class: {
        'skeleton-content': true
      }
    }, content)
  }
}
</script>



// WEBPACK FOOTER //
// src/module/skeleton/content.vue